/* eslint-disable jsx-a11y/label-has-associated-control */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import Api from '../../helpers/Api';
import Spinner from '../../common/Spinner/Spinner';
import ChartsOfListeners from '../chartsOfListeners/components/ChartsOfListenersComponent';
import { showError } from '../../common/A1Alert/A1Alert';

// Calculate 7 days ago
const days = 7; // Days you want to subtract
const date = new Date();
const last = new Date(date.getTime() - (days * 24 * 60 * 60 * 1000));

class A1StatsComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            listeners: [],
            listenersError: false,
            userCanReadStatistics: false,
            userCanCleanCache: false,
            userCanSeeFilials: false,
            content: {},
            updateChart: false,
            graphTypes: {
                total: true,
                https: true,
                http: false,
                android: false,
                ios: false,
                newradio: false,
                baixo: false,
                hd: false,
                alexa: false,
                tuneIn: false,
                alexaRSK: false,
                facebook: false,
                bing: false,
                google: false,
                italy: false,
                italyBR: false,
                antena1pro: false,
                antena180: false,
                antena1mpb: false,
                antena12020: false,
                antena12010: false,
                antena1campinas: false,
                antena1piracicaba: false,
                antena1poa: false,
                antena1bh: false,
                antena1brasila: false,
                antena1ilhabela: false,
                antena1sjc: false,
            },
            graphDataTypes: {
                all: true,
                onlyMin: false,
                onlyMax: false,
                onlyMean: false,
            },
            selectedGraphDataType: 'all',
            startDate: `${last.getFullYear()}-${(`0${last.getMonth() + 1}`).slice(-2)}-${(`0${last.getDate()}`).slice(-2)}`,
            endDate: `${date.getFullYear()}-${(`0${date.getMonth() + 1}`).slice(-2)}-${(`0${date.getDate()}`).slice(-2)}`,
            startTime: '00:00',
            endTime: '23:59',
            groupBy: 'hour',
            filteredTimeData: [],
            filteredListenersData: {},
            loadingReport: false,
            comReportTimestamps: '',
            comReportTimeData: [],
            comReportListenersData: {},
            comReportTotalListeners: {},
            comReportTotalNumInserts: null,
        };

        this._handleInputChange = this._handleInputChange.bind(this);

        this._handleDataTypeChange = this._handleDataTypeChange.bind(this);

        this._handleSubmit = this._handleSubmit.bind(this);

        this.listenersTimerHandle = null;

        this._getListeners = this._getListeners.bind(this);
    }


    componentDidMount() {
        if (this.props.token) {
            this._getUserPermissions(this.props.token);

            this._getListeners(this.props.token);

            this.listenersTimerHandle = setInterval(this._getListeners, 20000);

            this._requestData(this.props.token);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.token !== this.props.token && this.props.token) {
            this._getUserPermissions(this.props.token);

            this._getListeners(this.props.token);

            this.listenersTimerHandle = setInterval(this._getListeners, 20000);

            this._requestData(this.props.token);
        }
    }

    componentWillUnmount() {
        clearInterval(this.listenersTimerHandle);
    }


    _handleSelect = (event) => {
        const target = event.target;

        this.setState({
            groupBy: target.options[target.selectedIndex].value,
        });
    }

    _handleSubmit = (event) => {
        event.preventDefault();

        this._requestData(this.props.token);
    }

    _getComReport = (event) => {
        event.preventDefault();

        if (!this.state.comReportTimestamps) {
            return showError('Nenhuma timestamp fornecida!');
        }

        const timestamps = this.state.comReportTimestamps;
        const query = `/api/v1/stats/getListenersByDates?timestamps=${encodeURIComponent(timestamps)}`;

        this.setState({
            loadingReport: true,
        });

        return Api.get(query, this.props.token)
            .then((json) => {
                if (json.status === 'success') {
                    this.setState({
                        comReportTimeData: json.data.timeData,
                        comReportListenersData: json.data.listenersData,
                        comReportTotalListeners: json.data.totalListeners,
                        comReportTotalNumInserts: json.data.totalNumInserts,
                        loadingReport: false,
                    });

                    return true;
                }

                this.setState({
                    comReportTimeData: [],
                    comReportListenersData: {},
                    comReportTotalListeners: {},
                    comReportTotalNumInserts: null,
                    loadingReport: false,
                });

                showError(json.message);

                throw `_getComReport, got error from server: ${json.message}`;
            })
            .catch((error) => {
                this.setState({
                    comReportTimeData: [],
                    comReportListenersData: {},
                    comReportTotalListeners: {},
                    comReportTotalNumInserts: null,
                    loadingReport: false,
                });

                // eslint-disable-next-line no-console
                console.error('_getComReport got error:', error);
            });
    }

    _handleInputChange(event) {
        const target = event.target;
        const name = target.name;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        if (name === 'start') {
            this.setState({
                startDate: value,
            });
        }

        if (name === 'end') {
            this.setState({
                endDate: value,
            });
        }

        if (name === 'startTime') {
            this.setState({
                startTime: value,
            });
        }

        if (name === 'endTime') {
            this.setState({
                endTime: value,
            });
        }

        if (name === 'comReportTimestamps') {
            this.setState({
                comReportTimestamps: value,
            });
        }

        if (target.type === 'checkbox') {
            this.setState((prevState) => ({
                graphTypes: {
                    ...prevState.graphTypes,
                    [name]: value,
                },
            }));
        }
    }

    _handleDataTypeChange(event) {
        // It is only possible to toggle between the dataType checkboxes and at least must always be selected
        const target = event.target;
        const name = target.name;

        this.setState((prevState) => ({
            graphDataTypes: Object.fromEntries(Object.keys(prevState.graphDataTypes).map((key) => [key, key === name])),
            selectedGraphDataType: name,
        }));
    }

    // eslint-disable-next-line class-methods-use-this
    _stopPlayer(element) {
        // need to reset the player src, or the stream keeps downloading forever, even when stopped
        const src = element.target.getAttribute('srcdata');

        // eslint-disable-next-line no-param-reassign
        element.target.src = null;

        element.target.load();

        // eslint-disable-next-line no-param-reassign
        element.target.src = src;
    }

    _mountFilials() {
        return this.state.content.affiliates.map((element) => {
            const src = this.state.content.affiliatesUrl + element.sid;

            return (
                <div key={element.sid} className="filialElement">
                    <h2>
                        {element.name}
                    </h2>
                    <div className="filialPlayerElement">
                        { /* eslint-disable-next-line jsx-a11y/media-has-caption */}
                        <audio controls preload="none" src={src} onPause={this._stopPlayer}>
                            O seu navegador não consegue tocar esse stream.
                        </audio>
                    </div>
                </div>
            );
        });
    }

    // eslint-disable-next-line class-methods-use-this
    _showError() {
        return (
            <div className="listenersError">
                Connection error!
            </div>
        );
    }

    _getListeners(token = this.props.token) {
        const query = '/api/v1/stats/getListeners';

        Api.get(query, token)
            .then((json) => {
                if (json.status === 'success') {
                    this.setState({
                        listeners: json.data.listeners,
                        listenersError: false,
                    });

                    return true;
                }

                throw `_getListeners, got error from server: ${json.message}`;
            })
            .catch((error) => {
                this.setState({ listenersError: true });

                // eslint-disable-next-line no-console
                console.error('_getListeners got error:', error);
            });
    }

    _getUserPermissions(token) {
        const query = '/api/v1/stats/getUserPermissions';

        Api.get(query, token)
            .then((json) => {
                if (json.status === 'success') {
                    const userPermissions = json.data.userPermissions;
                    // 1 = ler_estatisticas
                    // 2 = controles
                    // 3 = filiais
                    const content = json.data.content; // only includes content that the user can see

                    this.setState({
                        userCanReadStatistics: userPermissions.includes(1),
                        userCanCleanCache: userPermissions.includes(2),
                        userCanSeeFilials: userPermissions.includes(3),
                        content,
                    });

                    return true;
                }

                throw `_getUserPermissions, got error from server: ${json.message}`;
            })
            .catch((error) => {
                // eslint-disable-next-line no-console
                console.error('_getUserPermissions got error:', error);
            });
    }

    _requestData(token) {
        const startDate = `${this.state.startDate} ${this.state.startTime}`;
        const endDate = `${this.state.endDate} ${this.state.endTime}`;
        let query = '/api/v1/stats/getFilteredListeners?';

        query += this.state.startDate && `startDate=${startDate}&`;

        query += this.state.endDate && `endDate=${endDate}&`;

        query += this.state.groupBy && `choiceTime=${this.state.groupBy}&`;

        Object.keys(this.state.graphTypes).map((key) => {
            query += this.state.graphTypes[key] ? `listenersTypes[]=${key}&` : '';

            return true;
        });

        this.setState({
            updateChart: true,
        });

        Api.get(query, token)
            .then((json) => {
                if (json.status === 'success') {
                    this.setState({
                        filteredListenersData: json.data.listenersData,
                        filteredTimeData: json.data.timeData,
                        updateChart: false,
                    });

                    return true;
                }

                this.setState({
                    updateChart: false,
                });

                showError(json.message);

                throw `_requestData, got error from server: ${json.message}`;
            })
            .catch((error) => {
                this.setState({
                    updateChart: false,
                });

                // eslint-disable-next-line no-console
                console.error('_requestData got error:', error);
            });
    }

    render() {
        const latestListeners = this.state.listeners[this.state.listeners.length - 1];
        const latestHttps = latestListeners ? latestListeners.listeners.https : null;
        const latestHttp = latestListeners ? latestListeners.listeners.http : null;
        const latestAndroid = latestListeners ? latestListeners.listeners.android : null;
        const latestIos = latestListeners ? latestListeners.listeners.ios : null;
        const latestFacebook = latestListeners ? latestListeners.listeners.facebook : null;
        const latestGoogle = latestListeners ? latestListeners.listeners.google : null;
        const latestBing = latestListeners ? latestListeners.listeners.bing : null;
        const latestOld = latestListeners ? latestListeners.listeners.newradio : null;
        const latestHd = latestListeners ? latestListeners.listeners.casterSid1 : null;
        const latestBaixo = latestListeners ? latestListeners.listeners.casterSid2 : null;
        const latestItaly = latestListeners ? latestListeners.listeners.italySid1 + latestListeners.listeners.italySid2 : null;
        const latestItalyBR = latestListeners ? latestListeners.listeners.italySid3 : null;
        const latestAntena1pro = latestListeners ? latestListeners.listeners.crosshostExtraSid1 : null;
        const latestAntena180 = latestListeners ? latestListeners.listeners.crosshostExtraSid2 : null;
        const latestAntena1mpb = latestListeners ? latestListeners.listeners.crosshostExtraSid3 : null;
        const latestAntena12020 = latestListeners ? latestListeners.listeners.crosshostExtraSid4 : null;
        const latestAntena12010 = latestListeners ? latestListeners.listeners.crosshostExtraSid5 : null;
        const latestAntena1campinas = latestListeners ? latestListeners.listeners.crosshostExtraSid6 : null;
        const latestAntena1piracicaba = latestListeners ? latestListeners.listeners.crosshostExtraSid7 : null;
        const latestAntena1poa = latestListeners ? latestListeners.listeners.crosshostExtraSid8 : null;
        const latestAntena1bh = latestListeners ? latestListeners.listeners.crosshostExtraSid9 : null;
        const latestAntena1brasilia = latestListeners ? latestListeners.listeners.crosshostExtraSid10 : null;
        const latestAntena1ilhabela = latestListeners ? latestListeners.listeners.crosshostExtraSid11 : null;
        const latestAntena1sjc = latestListeners ? latestListeners.listeners.crosshostExtraSid12 : null;
        const latestAlexa = latestListeners ? latestListeners.listeners.alexa : null;
        const latestTuneIn = latestListeners ? latestListeners.listeners.tuneIn : null;
        const latestAlexaRSK = latestListeners ? latestListeners.listeners.alexaRSK : null;
        const listenersError = this.state.listenersError;

        const listeners = this.state.listeners;

        const timeData = [];

        const listenersDataTotal = {};

        listenersDataTotal.total = [];

        listeners.map((data) => {
            // if any one of those is undefined (or null), we skip this data point
            // Facebook, Google, Bing appear to be deactivated since 03.09.25.
            // To avoid them causing wrong results, we remove them here, but keep it in the historic data below.
            if (!(data.listeners.https
                + data.listeners.http
                + data.listeners.newradio
                + data.listeners.android
                // + data.listeners.facebook
                // + data.listeners.google
                // + data.listeners.bing
                + data.listeners.ios
                + data.listeners.casterSid1
                + data.listeners.casterSid2
                + data.listeners.alexa
                + data.listeners.tuneIn
                + data.listeners.alexaRSK)) {
                return false;
            }

            timeData.push(data.time);

            listenersDataTotal.total.push({
                x: data.listeners.https
                    + data.listeners.http
                    // + data.listeners.facebook
                    // + data.listeners.google
                    // + data.listeners.bing
                    + data.listeners.newradio
                    + data.listeners.android
                    + data.listeners.ios
                    + data.listeners.casterSid1
                    + data.listeners.casterSid2
                    + data.listeners.alexa
                    + data.listeners.tuneIn
                    + data.listeners.alexaRSK,
            });

            return true;
        });

        const latestTotal = latestHttps
            + latestHttp
            + latestAndroid
            + latestIos
            + latestOld
            + latestHd
            + latestBaixo
            // + latestFacebook
            // + latestGoogle
            // + latestBing
            + latestAlexa
            + latestTuneIn
            + latestAlexaRSK;

        const windowWidth = this.props.breakpoint.width;
        let chartWidth; let
            chartHeight;

        // verify width charts
        if (this.props.breakpoint.isExtraLarge) {
            chartWidth = windowWidth - 200;

            chartHeight = 400;
        } else if (this.props.breakpoint.isLarge) {
            chartWidth = windowWidth - 100;

            chartHeight = 300;
        } else {
            // all other sizes (mobile)
            chartWidth = windowWidth - 100;

            chartHeight = 300;
        }

        // commercial reports stuff
        const comReportTotalListeners = Object.entries(this.state.comReportTotalListeners);
        const comReportListenersData = Object.entries(this.state.comReportListenersData);
        const comReportDetails = {
            total: 0,
            totalWeb: 0,
            totalApps: 0,
            totalWebPercentage: 0,
            totalAppsPercentage: 0,
        };

        comReportTotalListeners.forEach((el) => {
            if (el[0] === 'android' || el[0] === 'ios') {
                // sum for total apps
                comReportDetails.totalApps += el[1];
            } else if (el[0] === 'total') {
                // save the total, to calculate the percentages
                comReportDetails.total = el[1];
            } else {
                // sum up everything else as web traffic
                comReportDetails.totalWeb += el[1];
            }
        });

        comReportDetails.totalWebPercentage = (comReportDetails.totalWeb / (comReportDetails.total / 100)).toFixed(1);

        comReportDetails.totalAppsPercentage = (comReportDetails.totalApps / (comReportDetails.total / 100)).toFixed(1);

        return (
            <div className="a1StatsContainer">
                <h1 key="statistics">Estatisticas da Antena 1</h1>
                <br />
                {!this.props.token ?
                    <div key="listenersContainer" className="listenersContainer">
                        <h3>Você precisa estar logado para ver as estatísticas</h3>
                    </div>
                    : this.state.userCanReadStatistics ?
                        <div key="listenersContainer" className="listenersContainer">
                            <div className="listenersTotal">
                                <div className="totalNumber">
                                    <h2>
                                        # Total de ouvintes
                                        <br />
                                        (sem Italia e sem PRO)
                                    </h2>
                                    <div className={listenersError ? 'listenersNum errorListeners' : 'listenersNum'}>
                                        {latestTotal || '...'}
                                    </div>
                                </div>
                                <div className="containerChart">
                                    <ChartsOfListeners
                                        timeData={timeData}
                                        listenersData={listenersDataTotal}
                                        chartWidth={chartWidth}
                                        chartHeight={chartHeight - 100}
                                        legend={false}
                                        dataType="total"
                                    />
                                </div>
                            </div>
                            <div className="listeners">
                                <h2>
                                    # Facebook (deactivated?)
                                </h2>
                                <div className={listenersError ? 'listenersNum errorListeners' : 'listenersNum'}>
                                    {latestFacebook !== undefined
                                        ? latestFacebook
                                        : '...'}
                                    {listenersError && this._showError()}
                                </div>
                            </div>
                            <div className="listeners">
                                <h2>
                                    # Google (deactivated?)
                                </h2>
                                <div className={listenersError ? 'listenersNum errorListeners' : 'listenersNum'}>
                                    {latestGoogle !== undefined
                                        ? latestGoogle
                                        : '...'}
                                    {listenersError && this._showError()}
                                </div>
                            </div>
                            <div className="listeners">
                                <h2>
                                    # Bing (deactivated?)
                                </h2>
                                <div className={listenersError ? 'listenersNum errorListeners' : 'listenersNum'}>
                                    {latestBing !== undefined
                                        ? latestBing
                                        : '...'}
                                    {listenersError && this._showError()}
                                </div>
                            </div>
                            <hr />
                            <div className="listeners">
                                <h2>
                                    # Página
                                </h2>
                                <div className={listenersError ? 'listenersNum errorListeners' : 'listenersNum'}>
                                    {latestHttps !== undefined
                                        ? latestHttps
                                        : '...'}
                                    {listenersError && this._showError()}
                                </div>
                            </div>
                            <div className="listeners">
                                <h2>
                                    # HD
                                </h2>
                                <div className={listenersError ? 'listenersNum errorListeners' : 'listenersNum'}>
                                    {latestHd !== undefined
                                        ? latestHd
                                        : '...'}
                                    {listenersError && this._showError()}
                                </div>
                            </div>
                            <div className="listeners">
                                <h2>
                                    # Baixo
                                </h2>
                                <div className={listenersError ? 'listenersNum errorListeners' : 'listenersNum'}>
                                    {latestBaixo !== undefined
                                        ? latestBaixo
                                        : '...'}
                                    {listenersError && this._showError()}
                                </div>
                            </div>
                            <div className="listeners">
                                <h2>
                                    # http/alt
                                </h2>
                                <div className={listenersError ? 'listenersNum errorListeners' : 'listenersNum'}>
                                    {latestHttp !== undefined
                                        ? latestHttp
                                        : '...'}
                                    {listenersError && this._showError()}
                                </div>
                            </div>
                            <div className="listeners">
                                <h2>
                                    # Android App
                                </h2>
                                <div className={listenersError ? 'listenersNum errorListeners' : 'listenersNum'}>
                                    {latestAndroid !== undefined
                                        ? latestAndroid
                                        : '...'}
                                    {listenersError && this._showError()}
                                </div>
                            </div>
                            <div className="listeners">
                                <h2>
                                    # ios App
                                </h2>
                                <div className={listenersError ? 'listenersNum errorListeners' : 'listenersNum'}>
                                    {latestIos !== undefined
                                        ? latestIos
                                        : '...'}
                                    {listenersError && this._showError()}
                                </div>
                            </div>
                            <div className="listeners">
                                <h2>
                                    # Antigo
                                </h2>
                                <div className={listenersError ? 'listenersNum errorListeners' : 'listenersNum'}>
                                    {latestOld !== undefined
                                        ? latestOld
                                        : '...'}
                                    {listenersError && this._showError()}
                                </div>
                            </div>
                            <div className="listeners">
                                <h2>
                                    # Alexa (skill)
                                </h2>
                                <div className={listenersError ? 'listenersNum errorListeners' : 'listenersNum'}>
                                    {latestAlexa !== undefined
                                        ? latestAlexa
                                        : '...'}
                                    {listenersError && this._showError()}
                                </div>
                            </div>
                            <div className="listeners">
                                <h2>
                                    # TuneIn
                                </h2>
                                <div className={listenersError ? 'listenersNum errorListeners' : 'listenersNum'}>
                                    {latestTuneIn !== undefined
                                        ? latestTuneIn
                                        : '...'}
                                    {listenersError && this._showError()}
                                </div>
                            </div>
                            <div className="listeners">
                                <h2>
                                    # Alexa (RSK)
                                </h2>
                                <div className={listenersError ? 'listenersNum errorListeners' : 'listenersNum'}>
                                    {latestAlexaRSK !== undefined
                                        ? latestAlexaRSK
                                        : '...'}
                                    {listenersError && this._showError()}
                                </div>
                            </div>
                            <hr />
                            <div className="listeners">
                                <h2>
                                    # Campinas (página)
                                </h2>
                                <div className={listenersError ? 'listenersNum errorListeners' : 'listenersNum'}>
                                    {latestAntena1campinas !== undefined
                                        ? latestAntena1campinas
                                        : '...'}
                                    {listenersError && this._showError()}
                                </div>
                            </div>
                            <div className="listeners">
                                <h2>
                                    # Piracicaba (página)
                                </h2>
                                <div className={listenersError ? 'listenersNum errorListeners' : 'listenersNum'}>
                                    {latestAntena1piracicaba !== undefined
                                        ? latestAntena1piracicaba
                                        : '...'}
                                    {listenersError && this._showError()}
                                </div>
                            </div>
                            <div className="listeners">
                                <h2>
                                    # Porto Alegre (página)
                                </h2>
                                <div className={listenersError ? 'listenersNum errorListeners' : 'listenersNum'}>
                                    {latestAntena1poa !== undefined
                                        ? latestAntena1poa
                                        : '...'}
                                    {listenersError && this._showError()}
                                </div>
                            </div>
                            <div className="listeners">
                                <h2>
                                    # Belo Horizonte (página)
                                </h2>
                                <div className={listenersError ? 'listenersNum errorListeners' : 'listenersNum'}>
                                    {latestAntena1bh !== undefined
                                        ? latestAntena1bh
                                        : '...'}
                                    {listenersError && this._showError()}
                                </div>
                            </div>
                            <div className="listeners">
                                <h2>
                                    # Brasilia (página)
                                </h2>
                                <div className={listenersError ? 'listenersNum errorListeners' : 'listenersNum'}>
                                    {latestAntena1brasilia !== undefined
                                        ? latestAntena1brasilia
                                        : '...'}
                                    {listenersError && this._showError()}
                                </div>
                            </div>
                            <div className="listeners">
                                <h2>
                                    # Ilhabela (página)
                                </h2>
                                <div className={listenersError ? 'listenersNum errorListeners' : 'listenersNum'}>
                                    {latestAntena1ilhabela !== undefined
                                        ? latestAntena1ilhabela
                                        : '...'}
                                    {listenersError && this._showError()}
                                </div>
                            </div>
                            <div className="listeners">
                                <h2>
                                    # SJC (página)
                                </h2>
                                <div className={listenersError ? 'listenersNum errorListeners' : 'listenersNum'}>
                                    {latestAntena1sjc !== undefined
                                        ? latestAntena1sjc
                                        : '...'}
                                    {listenersError && this._showError()}
                                </div>
                            </div>
                            <hr />
                            <div className="listeners">
                                <h2>
                                    # Italia (BR)
                                </h2>
                                <div className={listenersError ? 'listenersNum errorListeners' : 'listenersNum'}>
                                    {latestItalyBR !== undefined
                                        ? latestItalyBR
                                        : '...'}
                                    {listenersError && this._showError()}
                                </div>
                            </div>
                            <div className="listeners">
                                <h2>
                                    # Italia (IT)
                                </h2>
                                <div className={listenersError ? 'listenersNum errorListeners' : 'listenersNum'}>
                                    {latestItaly !== undefined
                                        ? latestItaly
                                        : '...'}
                                    {listenersError && this._showError()}
                                </div>
                            </div>
                            <hr />
                            <div className="listeners pro">
                                <h2>
                                    # PRO (Pro)
                                </h2>
                                <div className={listenersError ? 'listenersNum errorListeners' : 'listenersNum'}>
                                    {latestAntena1pro !== undefined
                                        ? latestAntena1pro
                                        : '...'}
                                    {listenersError && this._showError()}
                                </div>
                            </div>
                            <div className="listeners pro">
                                <h2>
                                    # Hits (Pro)
                                </h2>
                                <div className={listenersError ? 'listenersNum errorListeners' : 'listenersNum'}>
                                    {latestAntena180 !== undefined
                                        ? latestAntena180
                                        : '...'}
                                    {listenersError && this._showError()}
                                </div>
                            </div>
                            <div className="listeners pro">
                                <h2>
                                    # MPB (Pro)
                                </h2>
                                <div className={listenersError ? 'listenersNum errorListeners' : 'listenersNum'}>
                                    {latestAntena1mpb !== undefined
                                        ? latestAntena1mpb
                                        : '...'}
                                    {listenersError && this._showError()}
                                </div>
                            </div>
                            <div className="listeners pro">
                                <h2>
                                    # 2020 (Pro)
                                </h2>
                                <div className={listenersError ? 'listenersNum errorListeners' : 'listenersNum'}>
                                    {latestAntena12020 !== undefined
                                        ? latestAntena12020
                                        : '...'}
                                    {listenersError && this._showError()}
                                </div>
                            </div>
                            <div className="listeners pro">
                                <h2>
                                    # 2010 (Pro)
                                </h2>
                                <div className={listenersError ? 'listenersNum errorListeners' : 'listenersNum'}>
                                    {latestAntena12010 !== undefined
                                        ? latestAntena12010
                                        : '...'}
                                    {listenersError && this._showError()}
                                </div>
                            </div>
                            <hr />
                            <div className="containerGraph">
                                <h1>Historico de ouvintes</h1>
                                <form onSubmit={this._handleSubmit}>
                                    <div className="containerTime">
                                        <label>
                                            start:
                                            {' '}
                                            <input type="date" name="start" value={this.state.startDate} onChange={this._handleInputChange} />
                                            <input type="time" value={this.state.startTime} name="startTime" onChange={this._handleInputChange} />
                                        </label>
                                        <label>
                                            end:
                                            {' '}
                                            <input type="date" name="end" value={this.state.endDate} onChange={this._handleInputChange} />
                                            <input type="time" name="endTime" value={this.state.endTime} onChange={this._handleInputChange} />
                                        </label>
                                    </div>
                                    <div className="containerIterval">
                                        <select value={this.state.groupBy} onChange={this._handleSelect}>
                                            <option value="minute">Minute</option>
                                            <option value="hour">Hour</option>
                                            <option value="day">Day</option>
                                            <option value="week">Week</option>
                                            <option value="month">Month</option>
                                        </select>
                                    </div>
                                    <div className="containerQtdStreaming">
                                        <label>
                                            <input type="checkbox" checked={this.state.graphTypes.total} name="total" onChange={this._handleInputChange} />
                                            Total (sem italia)
                                        </label>
                                        <label>
                                            <input type="checkbox" checked={this.state.graphTypes.https} name="https" onChange={this._handleInputChange} />
                                            Https
                                        </label>
                                        <label>
                                            <input type="checkbox" checked={this.state.graphTypes.http} name="http" onChange={this._handleInputChange} />
                                            Http
                                        </label>
                                        <label>
                                            <input type="checkbox" checked={this.state.graphTypes.android} name="android" onChange={this._handleInputChange} />
                                            Android
                                        </label>
                                        <label>
                                            <input type="checkbox" checked={this.state.graphTypes.ios} name="ios" onChange={this._handleInputChange} />
                                            iOS
                                        </label>
                                        <label>
                                            <input type="checkbox" checked={this.state.graphTypes.hd} name="hd" onChange={this._handleInputChange} />
                                            HD
                                        </label>
                                        <label>
                                            <input type="checkbox" checked={this.state.graphTypes.baixo} name="baixo" onChange={this._handleInputChange} />
                                            Baixo
                                        </label>
                                        <label>
                                            <input type="checkbox" checked={this.state.graphTypes.newradio} name="newradio" onChange={this._handleInputChange} />
                                            Antigo
                                        </label>
                                        <label>
                                            <input type="checkbox" checked={this.state.graphTypes.alexa} name="alexa" onChange={this._handleInputChange} />
                                            Alexa Skill
                                        </label>
                                        <label>
                                            <input type="checkbox" checked={this.state.graphTypes.tuneIn} name="tuneIn" onChange={this._handleInputChange} />
                                            TuneIn
                                        </label>
                                        <label>
                                            <input type="checkbox" checked={this.state.graphTypes.alexaRSK} name="alexaRSK" onChange={this._handleInputChange} />
                                            Alexa RSK
                                        </label>
                                        <hr />
                                        <label>
                                            <input type="checkbox" checked={this.state.graphTypes.facebook} name="facebook" onChange={this._handleInputChange} />
                                            Facebook
                                        </label>
                                        <label>
                                            <input type="checkbox" checked={this.state.graphTypes.google} name="google" onChange={this._handleInputChange} />
                                            Google
                                        </label>
                                        <label>
                                            <input type="checkbox" checked={this.state.graphTypes.bing} name="bing" onChange={this._handleInputChange} />
                                            Bing
                                        </label>
                                        <hr />
                                        <label>
                                            <input type="checkbox" checked={this.state.graphTypes.antena1campinas} name="antena1campinas" onChange={this._handleInputChange} />
                                            Campinas
                                        </label>
                                        <label>
                                            <input type="checkbox" checked={this.state.graphTypes.antena1piracicaba} name="antena1piracicaba" onChange={this._handleInputChange} />
                                            Piracicaba
                                        </label>
                                        <label>
                                            <input type="checkbox" checked={this.state.graphTypes.antena1poa} name="antena1poa" onChange={this._handleInputChange} />
                                            Porto Alegre
                                        </label>
                                        <label>
                                            <input type="checkbox" checked={this.state.graphTypes.antena1bh} name="antena1bh" onChange={this._handleInputChange} />
                                            Belo Horizonte
                                        </label>
                                        <label>
                                            <input type="checkbox" checked={this.state.graphTypes.antena1brasilia} name="antena1brasilia" onChange={this._handleInputChange} />
                                            Brasilia
                                        </label>
                                        <label>
                                            <input type="checkbox" checked={this.state.graphTypes.antena1ilhabela} name="antena1ilhabela" onChange={this._handleInputChange} />
                                            Ilhabela
                                        </label>
                                        <label>
                                            <input type="checkbox" checked={this.state.graphTypes.antena1sjc} name="antena1sjc" onChange={this._handleInputChange} />
                                            SJC
                                        </label>
                                        <hr />
                                        <label>
                                            <input type="checkbox" checked={this.state.graphTypes.italy} name="italy" onChange={this._handleInputChange} />
                                            Italia-IT
                                        </label>
                                        <label>
                                            <input type="checkbox" checked={this.state.graphTypes.italyBR} name="italyBR" onChange={this._handleInputChange} />
                                            Italia-BR
                                        </label>
                                        <hr />
                                        <label className="pro">
                                            <input type="checkbox" checked={this.state.graphTypes.antena1pro} name="antena1pro" onChange={this._handleInputChange} />
                                            Antena 1 Pro
                                        </label>
                                        <label className="pro">
                                            <input type="checkbox" checked={this.state.graphTypes.antena180} name="antena180" onChange={this._handleInputChange} />
                                            Antena 1 Hits
                                        </label>
                                        <label className="pro">
                                            <input type="checkbox" checked={this.state.graphTypes.antena1mpb} name="antena1mpb" onChange={this._handleInputChange} />
                                            Antena 1 MPB
                                        </label>
                                        <label className="pro">
                                            <input type="checkbox" checked={this.state.graphTypes.antena12020} name="antena12020" onChange={this._handleInputChange} />
                                            Antena 1 2020
                                        </label>
                                        <label className="pro">
                                            <input type="checkbox" checked={this.state.graphTypes.antena12010} name="antena12010" onChange={this._handleInputChange} />
                                            Antena 1 2010
                                        </label>
                                    </div>
                                    <div className="btnSub">
                                        <button type="submit" className="a1StatsButton">
                                            update
                                            {this.state.updateChart && <Spinner customClass="spinnerStats" />}
                                        </button>
                                    </div>
                                    <div className="containerGraphConfig">
                                        <label>
                                            <input type="checkbox" checked={this.state.graphDataTypes.all} name="all" onChange={this._handleDataTypeChange} />
                                            Padrão
                                        </label>
                                        <label>
                                            <input type="checkbox" checked={this.state.graphDataTypes.onlyMax} name="onlyMax" onChange={this._handleDataTypeChange} />
                                            Só Max
                                        </label>
                                        <label>
                                            <input type="checkbox" checked={this.state.graphDataTypes.onlyMin} name="onlyMin" onChange={this._handleDataTypeChange} />
                                            Só Min
                                        </label>
                                        <label>
                                            <input type="checkbox" checked={this.state.graphDataTypes.onlyMean} name="onlyMean" onChange={this._handleDataTypeChange} />
                                            Só Média
                                        </label>
                                    </div>
                                </form>
                                {
                                    this.state.filteredListenersData ?
                                        <div className="containerChart">
                                            <ChartsOfListeners
                                                timeData={this.state.filteredTimeData}
                                                listenersData={this.state.filteredListenersData}
                                                chartWidth={chartWidth}
                                                chartHeight={chartHeight}
                                                legend
                                                dataType={this.state.selectedGraphDataType}
                                            />
                                        </div>
                                        : ' '
                                }
                            </div>
                            <div className="commercialsReport">
                                <h1>Relatório de impactos</h1>
                                <form onSubmit={this._getComReport}>
                                    <div className="containerTimestamps">
                                        <label htmlFor="comReportTimestamps">
                                            Coloque os Timestamps abaixo (um por linha no formato AAAA-MM-DD hh:mm:ss (BRT/GMT-3).
                                            Não coloque timestamps iguais ou muito pertos, tipo 17:39:55 e 17:40:10):
                                        </label>
                                        <textarea
                                            rows="4"
                                            cols="35"
                                            name="comReportTimestamps"
                                            placeholder="2019-01-29 21:05:00&#10;2019-01-29 21:06:00&#10;2019-01-30 00:00:00"
                                            wrap="hard"
                                            value={this.state.comReportTimestamps}
                                            onChange={this._handleInputChange}
                                        />
                                    </div>
                                    <div className="buttonGenerate">
                                        <button type="submit" className="a1StatsButton">
                                            Gerar relatório
                                            {this.state.loadingReport && <Spinner customClass="spinnerStats" />}
                                        </button>
                                    </div>
                                </form>
                                <div className="comReportResult">
                                    {
                                        comReportTotalListeners.length > 0 && [
                                            <table key="comReportTable">
                                                <tbody>
                                                    <tr>
                                                        <th>
                                                            Data
                                                        </th>
                                                        <th>
                                                            Inserções
                                                        </th>
                                                        {
                                                            comReportTotalListeners.map((el) => (
                                                                <th key={`tableHeader+${el[0]}`}>
                                                                    {el[0]}
                                                                </th>))
                                                        }
                                                    </tr>
                                                    {
                                                        this.state.comReportTimeData.map((el, index) => (
                                                            <tr key={`tableRow+${el.date}`}>
                                                                <td>
                                                                    {new Date(el.date).toLocaleDateString('pt-BR', { timeZone: 'America/Sao_Paulo' })}
                                                                </td>
                                                                <td>
                                                                    {el.numInserts}
                                                                </td>
                                                                {
                                                                    comReportListenersData.map((el2) => (
                                                                        <td key={`tableColumn+${el.date}+${el2}`}>
                                                                            {el2[1][index]}
                                                                        </td>
                                                                    ))
                                                                }
                                                            </tr>
                                                        ))
                                                    }
                                                    <tr>
                                                        <td>
                                                            Total
                                                        </td>
                                                        <td>
                                                            {this.state.comReportTotalNumInserts}
                                                        </td>
                                                        {
                                                            comReportTotalListeners.map((el) => (
                                                                <td key={`tableColumn+${el[0]}+${el[1]}`}>
                                                                    {el[1]}
                                                                </td>
                                                            ))
                                                        }
                                                    </tr>
                                                </tbody>
                                            </table>,
                                            <div key="comReportCaption" className="comReportCaption">
                                                <p>
                                                    <b>Total:</b>
                                                    {' '}
                                                    {`${comReportDetails.total} (${this.state.comReportTotalNumInserts} insersões)`}
                                                    ,
                                                    {' '}
                                                    <b>Web:</b>
                                                    {' '}
                                                    {`${comReportDetails.totalWeb} (${comReportDetails.totalWebPercentage}%)`}
                                                    ,
                                                    {' '}
                                                    <b>Apps:</b>
                                                    {' '}
                                                    {`${comReportDetails.totalApps} (${comReportDetails.totalAppsPercentage}%)`}
                                                    <br />
                                                    <b>Obs:</b>
                                                    {' '}
                                                    https, http, newradio, hd, baixo, alexa, tuneIn e alexaRSK são streamings de web,
                                                    android e ios são dos nossos aplicativos.
                                                    <br />
                                                    <b>Obs2:</b>
                                                    {' '}
                                                    Um valor de 0 em algum campo não significa que o comercial não tocou no stream mas sim
                                                    que o sistema não conseguiu ler o stream nesse momento.
                                                    Se o não tive problemas com o streaming tem que estimar a quantidade das impactos baseado
                                                    nos outros dias e inserções.
                                                </p>
                                            </div>,
                                            <div key="comReportTableClearButton" className="buttonClearResult">
                                                <button className="a1StatsButton" type="button" onClick={() => this.setState({ comReportTimeData: [], comReportListenersData: {}, comReportTotalListeners: {} })}>
                                                    Limpar relatório
                                                </button>
                                            </div>,
                                        ]
                                    }
                                </div>
                            </div>
                            <hr />
                        </div>
                        :
                        <div key="listenersContainer" className="listenersContainer">
                            <h3>Você não tem permissão para ler as estatísticas.</h3>
                            <hr />
                        </div>}
                {(this.state.userCanCleanCache && this.props.token) &&
                    [
                        <h1 key="controls">Seção de controles</h1>,
                        <div key="controlsContainer" className="controlsContainer">
                            {
                                this.state.content.controlls
                                    ? this.state.content.controlls.map((controll) => (
                                        <p key={controll.title}>
                                            <a className="btnClearCache" target={controll.target} href={controll.href} title={controll.title}>
                                                {controll.title}
                                            </a>
                                        </p>))
                                    : 'carregando...'
                            }
                        </div>,
                    ]}
                {(this.state.userCanCleanCache && this.props.token) &&
                    [
                        <h1 key="links">Links</h1>,
                        <div key="linksContainer" className="linksContainer">
                            <ul className="linksContainer-list">
                                {
                                    this.state.content.links
                                        ? this.state.content.links.map((link) => (
                                            <li key={link.name} className="linksContainer-item" aria-level="1">
                                                {link.name}
                                                <a href={link.href} target={link.target} title={link.title}>
                                                    {link.href}
                                                </a>
                                            </li>))
                                        : 'carregando...'
                                }
                            </ul>
                        </div>,
                    ]}
                {(this.state.userCanSeeFilials && this.props.token) &&
                    [
                        <h1 key="filials">Filiais</h1>,
                        <div key="filialsContainer" className="filialsContainer">
                            <div className="filialsPlayersContainer">
                                {
                                    this.state.content.affiliates
                                        ? this._mountFilials()
                                        : 'carregando...'
                                }
                            </div>
                        </div>,
                    ]}
            </div>
        );
    }
}

A1StatsComponent.propTypes = exact({
    breakpoint: PropTypes.object.isRequired,
    token: PropTypes.string,
});

const mapStateToProps = (state) => ({
    token: state.profile.jwt,
    breakpoint: state.breakpointReducer,
});

// passing an empty object for mapDispatchToProps to avoid dispatch being passed on and causing prop-types-exact to complain
const A1StatsContainer = connect(
    mapStateToProps,
    {},
)(A1StatsComponent);

export default A1StatsContainer;
